<template>
  <div>
    <br />
    <template>  <!--v-if="!isLoading" -->
        <v-container class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="4">
              <v-card class="pa-2" outlined tile>
              TEST
              </v-card>
            </v-col>
            <v-col cols="6" md="8">
              <v-card class="pa-2" outlined tile>
                TEST
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      <!--
      <div class="product-category-section">
        <h2>PRODUCT CATEGORY LIST for {{ client.client.name }}</h2>
        <transition-group name="slide-up" tag="ul" appear>
          <ProductCategoryCard
            v-for="productCategory in productCategory.productCategories"
            :key="productCategory.id"
            :productCategory="productCategory"
            class="card-columns"
          />
        </transition-group>
      </div>

      <div class="product-section">
        <h2>PRODUCTS</h2>
        <ProductCard
          v-for="product in products"
          :key="product.id"
          :product="product"
          class="card-columns"
        />
      </div>

      <div class="unit-section">
        <h2>UNITS</h2>
        <transition-group name="slide-up" tag="ul" appear>
          <UnitCard
            v-for="unit in unit.units"
            :key="unit.id"
            :unit="unit"
            class="card-columns"
          />
        </transition-group>
      </div> -->
    </template>
    <!-- <p v-else>
      Loading products
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'
// import RegisterClient from '@/components/ui/RegisterClient.vue'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
    // RegisterClient
  },
  data() {
    return {
      id: this.client.id,  //! NE NAJDE client.id //
      isEditing: false,
      isLoading: true,
      products: [],
      prodInfo: null,
      loading: true,
      errored: false
    }
  },

  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/dashboard`)
      .then(response => {
        // handle success
        this.products = response.data.products.products
        this.isLoading = false
      })
      .catch(error => {
        // handle error
        console.log(error)
      })
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/cleaners`)
      .then(response => {
        this.cleanerInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    changeClientDetails() {
      if (
        confirm('are you sure? This will rewrite your excisting account details')
      ) {
        this.$store.dispatch('client/editClient', this.id)
      }
    },
    deleteCleaner() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('cleaner/removeCleaner', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    }

  },
  props: {
    client: {
      type: Object,
      required: true
    },
    cleaner: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.dashboard-links a {
  color: black !important;
  text-transform: uppercase;
  font-size: 1.5em;
  padding: 1em;
  margin-bottom: 1em;
}
.dashboard-links a:hover {
  text-decoration: none;
}
</style>
